import PropTypes from "prop-types"
import { useState } from "react"

import { ItemTitle, ItemAction, RetailPrice } from "areas/cart/components"
import Confirmation from "components/ui/confirmation"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const Addon = ({ boxAddon, item, removeAddonItem }) => {
  const [showRemoveDialog, toggleRemoveDialog] = useState(false)

  return (
    <div className="flex gap-10 pt-10">
      {boxAddon && (
        <>
          {boxAddon.image_url?.startsWith("https://user-uploads.jewlr.com") ? (
            <Image
              alt={boxAddon.title}
              className="mx-auto block bg-black p-8"
              data-cy={`cart-line-item-box-img-${item.style_code}`}
              height={128}
              src={boxAddon.image_url}
              title={boxAddon.title}
              width={128}
            />
          ) : (
            <Image
              alt={boxAddon.title}
              height={128}
              src={boxAddon.image_url}
              width={128}
            />
          )}
        </>
      )}
      {boxAddon && (
        <>
          <div className="flex-1">
            <ItemTitle className="mb-16">{boxAddon.title}</ItemTitle>
            <ItemAction onClick={() => toggleRemoveDialog(true)}>
              Remove
            </ItemAction>
          </div>
          <div className="text-right">
            {boxAddon.retail_price != boxAddon.price && (
              <p className="text-sale text-10 tablet:text-16 tablet:leading-none font-bold leading-normal tracking-wider">
                SALE
              </p>
            )}
            <p
              className={cn(
                "text-30 tablet:text-32 font-light leading-none",
                boxAddon.retail_price == boxAddon.price
                  ? "text-black"
                  : "text-sale"
              )}
            >
              {to_currency(boxAddon.price)}
            </p>
            {boxAddon.retail_price != boxAddon.price && (
              <RetailPrice>
                <strike>{to_currency(boxAddon.retail_price)}</strike>
                {/* <>RETAIL {to_currency(boxAddon.retail_price)}</> */}
              </RetailPrice>
            )}
          </div>
        </>
      )}
      <Confirmation
        cancelText="Cancel"
        confirmText="Yes"
        description={`Are you sure you want to remove this item from your ${jewlr_t("Cart")}?`}
        modalType="popup"
        onCancel={() => toggleRemoveDialog(false)}
        onConfirm={() => {
          removeAddonItem(boxAddon.id)
          toggleRemoveDialog(false)
        }}
        show={showRemoveDialog}
        title="Remove Item"
      />
    </div>
  )
}

Addon.propTypes = {
  boxAddon: PropTypes.object,
  item: PropTypes.object,
  removeAddonItem: PropTypes.func,
}

export default Addon
